<template>
  <ConfigLayout current="transfer" :hasMenu="!isTransfer" :loading="busy">
    <ConfigPage title="事業譲渡データ移管" :gap="30">
      <div v-if="isTransfer" class="status-layout">
        <div class="transfer">
          <div class="loading">
            <LoadingIndicator />
          </div>
          <p class="status">データ移管中...</p>
          <p class="note">※すべてのデータが反映するまで30分ほどかかる場合があります</p>
          <p class="store">{{ storeInformation }}</p>
        </div>
      </div>
      <div v-else-if="isCompleted" class="status-layout">
        <div class="completed">
          <p class="status">データ移管が完了いたしました</p>
          <p class="store">{{ storeInformation }}</p>
        </div>
      </div>
      <template v-else>
        <p class="note">
          データ移管を行います。<br />
          譲渡元のログインID（メールアドレス）・パスワードを入力して開始してください。
        </p>
        <div class="input-text-wrap">
          <AdornmentsInput
            type="email"
            :prefixIcon="MailInverseIcon"
            placeholder="メールアドレス"
            v-model="mailAddress"
          />
          <AdornmentsInput
            :type="passwordType"
            :prefixIcon="LockIcon"
            @focus="typeChange"
            placeholder="パスワード"
            v-model="password"
          />
          <Button primary :disabled="!isModified" @click="onSubmit">データ移管を開始</Button>
        </div>
      </template>
    </ConfigPage>
    <ExecuteModal v-if="executeModal" @close="executeModal = false" />
  </ConfigLayout>
</template>

<script>
import { mapState } from 'vuex'
import ConfigLayout from '@/components/templates/ConfigLayout'
import ConfigPage from '@/components/templates/ConfigPage'
import MailInverseIcon from '@/components/icons/mailInverse'
import LockIcon from '@/components/icons/lock'
import Button from '@/components/atoms/Button'
import AdornmentsInput from '@/components/molecules/AdornmentsInput'
import LoadingIndicator from '@/components/molecules/LoadingIndicator'
import Dialog from '@/components/molecules/ModalDialog'
import ExecuteModal from './ExecuteModal'

export default {
  name: 'Storetransfer',
  components: {
    ConfigLayout,
    ConfigPage,
    Button,
    AdornmentsInput,
    LoadingIndicator,
    ExecuteModal,
  },
  data() {
    return {
      mailAddress: '',
      password: '',
      passwordType: 'text',
      executeModal: false,
      MailInverseIcon,
      LockIcon,
    }
  },
  computed: {
    ...mapState({
      storetransfer: state => state.storetransfer,
      busy: state => state.storetransfer.busy,
      errFlg: state => state.storetransfer.errFlg,
      processing: state => state.storetransfer.processing,
    }),
    isModified() {
      return this.mailAddress && this.password
    },
    isTransfer() {
      return [1, 2].includes(this.storetransfer.processing)
    },
    isCompleted() {
      return this.storetransfer.processing === 3
    },
    storeInformation() {
      const transfer = this.storetransfer.transfer
      if (!transfer) return ''
      return `${transfer.type === 1 ? '譲渡先店舗' : '譲渡元店舗'}：${transfer.storeName}(${transfer.gNo})`
    },
  },
  watch: {
    isTransfer() {
      window.setTimeout(() => location.reload(), 60000)
    },
    isCompleted() {
      this.$store.dispatch('storetransfer/complete')
    },
  },
  async mounted() {
    await this.$store.dispatch('storetransfer/get')
    if (this.errFlg === 1) {
      await Dialog.show({
        title: 'エラー',
        message: 'データ移管に失敗しました。\nぐるなび台帳運営事務局にご連絡ください。',
        okText: '閉じる',
      })
    }
    // TODO 完了していたなら 事業譲渡非表示切替API を叩いてメニューを非表示にする
    // https://gnavi-work.gnavi.co.jp/wiki/pages/viewpage.action?pageId=63564702
  },
  methods: {
    async onSubmit() {
      const { mailAddress, password } = this
      if (await this.$store.dispatch('storetransfer/auth/start', { mailAddress, password })) {
        this.executeModal = true
      }
    },
    typeChange() {
      this.passwordType = 'password'
    },
  },
}
</script>

<style lang="postcss" scoped>
.note {
  font-size: 15px;
}

.input-text-wrap {
  background: var(--white);
  box-sizing: border-box;
  display: grid;
  grid-auto-flow: row;
  grid-gap: 24px;
  height: 408px;
  justify-content: center;
  padding: 104px 0;

  .wrapper {
    height: 48px;
    width: 384px;
  }

  >>> svg {
    fill: var(--gray-1);
  }

  button {
    width: 384px;
  }
}

.status-layout {
  align-items: center;
  background: var(--white);
  box-sizing: border-box;
  display: grid;
  height: 408px;
  justify-content: center;
  text-align: center;

  .loading {
    height: 80px;
  }

  .status {
    font-size: 21px;
  }

  .note {
    font-size: 11px;
  }

  .store {
    font-size: 15px;
  }

  .transfer {
    display: grid;
    grid-gap: 24px;
    grid-template-rows: 80px repeat(3, min-content);
    margin-bottom: 16px;
  }

  .completed {
    display: grid;
    grid-gap: 32px;
    grid-template-rows: repeat(2, min-content);
    margin-bottom: 4px;

    .status {
      font-weight: bold;
    }
  }
}
</style>
